
<template>
  <div>
    <v-row class="mx-3 mb-2">
      <div class="mr-3">
        <b>Dia: </b>
        {{ $moment(day+'T12:00:00').format('L') }}
      </div>
      <div v-for="base in keys.base" :key="base" class="mr-3">
        <b>{{key_map[base]}}: </b>
        <span v-if="base == 'sum'">
          {{ Number(val[base]).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
        </span>
        <span v-if="base != 'sum'">
          {{ val[base] }}
        </span>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import data_extract_mixin from '../data_extract_mixin'

export default {
  name: 'HeaderExtract',
  props: {
    val: {
      type: Object,
    },
    day: {
      type: String
    }
  },
  mixins: [data_extract_mixin],
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>